import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormatValueConversionPipe } from './format-value-conversion.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [FormatValueConversionPipe],
  exports: [FormatValueConversionPipe],
  providers: [FormatValueConversionPipe],
})
export class FormatValueConversionModule {}
